import { useEffect } from 'react'

export function useMountEffect(callback) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(callback, [])
}
